import {Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {

  constructor(private swUpdate: SwUpdate) {
    if (this.swUpdate.isEnabled) {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.checkForUpdates();
        }
      });
    }
  }

  public checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.available.subscribe(event => {
      this.updateVersion();
    });
    this.swUpdate.checkForUpdate();
  }

  private async updateVersion(): Promise<void> {
    console.log('updating to new version');
    await this.swUpdate.activateUpdate();
    document.location.reload();
  }
}
